import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Button } from '@ipc/ipc-components';
import DateFnsUtils from '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import locale from 'date-fns/locale/en-US';
import { getAssetType } from '../../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { tableLoadData } from '../../../../../common/tables/actions/ListTableActions';
import TableDefinitions from '../../../../../common/TableDefinitions';
import ListTable from '../../../../../common/tables/ListTable';
import { getColumns, getData, getIsLoading } from '../redux/selectors/RfidOnRouteNonConsolidatedReportSelectors';
import downloadTypes from '../../../../../common/tables/excel/DownloadTypes';

if (locale && locale.options) {
  locale.options.weekStartsOn = 1;
}

class RfidOnRouteNonConsolidatedReportContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showResult: false,
      startDate: moment().subtract(10, 'days').format('YYYY-MM-DD'),
      endDate: moment(new Date()).format('YYYY-MM-DD'),
    };
  }

  onStartDateChange = (newDate) => {
    this.setState({
      startDate: newDate,
    });
  }

  onEndDateChange = (newDate) => {
    this.setState({
      endDate: newDate,
    });
  }

  onCriteriaSearch = () => {
    this.setState({
      showResult: true,
    });

    this.props.tableLoadData(
      { tableId: 'REPORTING_RFID_ON_ROUTE_NON_CONSOLIDATED' },
      this.props.appContext.appContext,
      {
        endDate: this.state.endDate,
        rfid: this.props.row.original.rfid,
        startDate: this.state.startDate,
      },
    );
  };

  render() {
    return (
      <div>
        <table>
          <tbody>
            <tr>
              <td>RFID:</td>
              <td>{this.props.row.original.rfid}</td>
            </tr>
            <tr>
              <td>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                  <Grid container justify="space-around">
                    <KeyboardDatePicker
                      autoOk
                      disableToolbar
                      variant="inline"
                      format="dd-MM-yyyy"
                      margin="normal"
                      id="date-picker-inline"
                      label="Start date"
                      value={this.state.startDate}
                      onChange={this.onStartDateChange}
                      KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
              </td>
            </tr>
            <tr>
              <td>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                  <Grid container justify="space-around">
                    <KeyboardDatePicker
                      autoOk
                      disableToolbar
                      variant="inline"
                      format="dd-MM-yyyy"
                      margin="normal"
                      id="date-picker-inline"
                      label="End date"
                      value={this.state.endDate}
                      minDate={this.state.startDate}
                      onChange={this.onEndDateChange}
                      KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
              </td>
            </tr>
          </tbody>
        </table>
        <Button className="action-buttons" onClick={this.onCriteriaSearch}>
          Search
        </Button>
        {this.state.showResult && (
          <ListTable
            listId={TableDefinitions.REPORTING_RFID_ON_ROUTE_NON_CONSOLIDATED.id}
            loading={this.props.isLoading}
            columns={this.props.columns}
            data={this.props.data}
            keyField="rfid"
            selectCheckbox
            downloadType={downloadTypes.EXCEL}
            downloadFileAs="RFID_NON_CONSOLIDATED"
          />
        )}
      </div>
    );
  }
}

RfidOnRouteNonConsolidatedReportContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  appContext: PropTypes.objectOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  row: PropTypes.objectOf(PropTypes.shape),
  isLoading: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    appContext: getAssetType(state),
    isLoading: getIsLoading(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RfidOnRouteNonConsolidatedReportContainer);
